import React, { useState } from "react";
import ItemFeedback from "./ItemFeedback";
import ItemStars from "./ItemStars";
import ItemLogo from "./ItemLogo";

export default function Item({
  title,
  created,
  coach_feedback,
  program_feedback,
  member_first_name,
  member_last_name,
  menber_image,
  rating_details,
  session_room_link,
}) {
  return (
    <div className="program-item personal-program-card relative full-height in_process">
      <div className="row full-height">
        <div className="col-md-7 full-height">
          <div
            className="wrapper relative"
            style={{ width: "100%", height: "100%" }}
          >
            <h2 className="green text-in-one-string">{title}</h2>
            <ItemFeedback
              coachFeedback={coach_feedback}
              programFeedback={program_feedback}
            />
          </div>
        </div>
        <div className="col-md-5 full-height relative">
          <div
            className="gray-background relative"
            style={{ width: "100%", height: "100%" }}
          >
            <div className="wrapper">
              <ItemLogo
                firstName={member_first_name}
                lastName={member_last_name}
                avatar={menber_image}
                sessionRoomLink={session_room_link}
              />
              <div className="info">
                <div className="font-w-100 font-12">Started on {created}</div>
                <div className="mt20">
                  <ItemStars
                    key="coach"
                    title="Coach:"
                    feedback={coach_feedback}
                  />
                  <ItemStars
                    key="program"
                    title="Program:"
                    feedback={program_feedback}
                  />
                </div>
              </div>
              <div className="mt60">
                <a
                  href={rating_details}
                  target="_blank"
                  className="btn btn-green btn-outline"
                >
                  See Details
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
